<template>
  <span>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <h3 class="text-center">
          {{ $t("cars.add_car") }}
          <v-btn small icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
            }/${$root.$i18n.locale}/categories/7/guides/21`" target="_blank">
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <br v-if="$store.getters.getMainCompany.plan && $store.getters.getMainCompany.plan.cars_limit > 0"><span
            v-if="$store.getters.getMainCompany.plan && $store.getters.getMainCompany.plan.cars_limit > 0"
            class="text-subtitle-1"><span
              :class="$store.getters.getMainCompany.active_cars_count >= $store.getters.getMainCompany.plan.cars_limit ? 'error--text' : ''">{{
                $store.getters.getMainCompany.active_cars_count }}</span>/{{ $store.getters.getMainCompany.plan.cars_limit
              }}</span>
        </h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" sm="6" md="4" id="registration-step-29">
            <v-text-field v-model="car.car_name" :label="$t('cars.model')" :loading="isLoading" dense outlined required :hint="$t('tooltips.car_model')"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" id="registration-step-30">
            <v-text-field v-model="car.code" :label="$t('cars.code')" :loading="isLoading" dense outlined required 
              :hint="$t('cars.code_tooltip')"
              :rules="[(v) => !!v || $t('cars.code_required'), (v) => !v || v.length <= 8 || $t('cars.code_length')]"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" id="registration-step-31">
            <v-text-field v-model.number="car.sort" :label="$t('cars.sort_number')" :loading="isLoading" dense outlined :hint="$t('tooltips.car_sort')"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-select v-model="car.car_type" :items="current_object_types" :loading="isLoading" dense item-text="text" item-value="value"
              :label="$t('cars.body_type')" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" id="registration-step-33">
            <v-select v-model="car.car_class" :items="car_classes" :loading="isLoading" item-text="text" item-value="value" dense
              :label="$t('cars.class')" outlined></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field v-model.number="car.year" :label="$t('cars.year_created')" :loading="isLoading" type="number" dense
              outlined></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea v-model="car.description" :label="$t('cars.description')" :loading="isLoading" rows="1" auto-grow outlined></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-expansion-panels v-model="showDopPanel" :loading="isLoading">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h2 class="mb-0">
                    {{ $t("cars.extra_characteristics") }}
                  </h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" sm="6" md="3" id="registration-step-32">
                      <v-text-field v-model="car.number" :label="$t('cars.gov_number')" :placeholder="$t('cars.gov_number_pcl')"
                        dense outlined required v-tooltip="{
                          content: $t('tooltips.car_number'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.vin" :label="$t('cars.vin')" dense outlined v-tooltip="{
                        content: $t('tooltips.vin'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.body_number" :label="$t('cars.body_number')" dense hide-details
                        outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.pts" :label="$t('cars.reg_number')" dense outlined v-tooltip="{
                        content: $t('tooltips.car_passport'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.registration_certificate" :label="$t('cars.sts_number')" dense outlined
                        v-tooltip="{
                          content: $t('tooltips.car_sts'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.color" :label="$t('cars.color')" dense outlined v-tooltip="{
                        content: $t('tooltips.car_color'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-select v-model="car.transmission" :items="gears" item-text="text" item-value="value" dense
                        :label="$t('cars.gear_big')" outlined></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-select v-model="car.drive_unit" :items="drive_units" item-text="text" item-value="value" dense
                        :label="$t('cars.drive_unit')" outlined></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-select v-model="car.fuel" :items="fuels" dense item-text="text" item-value="value"
                        :label="$t('cars.fuel')" outlined></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.tank_value" :label="$t('cars.tank_value')" dense outlined v-tooltip="{
                        content: $t('tooltips.tank_value'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.gas_mileage" :label="$t('cars.gas_mileage')" dense
                        outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-select v-model="car.steering_side" :items="steering_side" dense :label="$t('cars.steering_side')"
                        outlined></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.number_doors" :label="$t('cars.number_doors')" dense
                        outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.number_seats" :label="$t('cars.number_seats')" dense outlined v-tooltip="{
                        content: $t('tooltips.number_seats'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.engine_capacity" :label="$t('cars.engine_capacity')" dense
                        outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.engine_power" :label="$t('cars.engine_power')" dense
                        outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.tire_size" :label="$t('cars.tire_size')" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" id="registration-step-35">
                      <v-text-field v-model.number="car.purchase_price" :label="$t('cars.purchase_price')" dense outlined
                        v-tooltip="{
                          content: $t('tooltips.purchase_price'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" id="registration-step-34">
                      <v-text-field v-model="car.purchase_date" type="date" :label="$t('cars.purchase_date')" dense outlined
                        v-tooltip="{
                          content: $t('tooltips.purchase_date'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-select v-model="car.interior" :items="interiors" item-text="text" item-value="value" dense
                        hide-details :label="$t('cars.interior')" outlined></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-select v-model="car.roof" :items="roofs" item-text="text" item-value="value" dense hide-details
                        :label="$t('cars.roof')" outlined></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.trunk_volume" :label="$t('cars.trunk_volume')" dense
                        hide-details outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.airbags" :label="$t('cars.airbags')" dense hide-details
                        outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.window_lifters" :label="$t('cars.window_lifters')" dense
                        hide-details outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.franchise" :label="$t('cars.franchise')" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.max_fine" :label="$t('cars.max_fine')" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.repair_cost" :label="$t('cars.repair_cost')" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.beacon_emai" :label="$t('cars.beacon_emai')" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.beacon_phone" :label="$t('cars.beacon_phone')" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="car.beacon_pin" :label="$t('cars.beacon_pin')" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.start_mileage" :label="$t('cars.start_mileage')" dense outlined v-tooltip="{
                        content: $t('tooltips.start_mileage'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model.number="car.mileage" :label="$t('cars.mileage')" dense outlined v-tooltip="{
                        content: $t('tooltips.current_mileage'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="car.custom_field_1" :label="$t('cars.custom_field_1')" dense
                        hide-details outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="car.custom_field_2" :label="$t('cars.custom_field_2')" dense
                        hide-details outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model.number="car.custom_field_3" :label="$t('cars.custom_field_3')" dense
                        hide-details outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <v-checkbox v-model="car.is_electropackage" :label="$t('cars.is_electropackage')" dense></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <v-checkbox :label="$t('cars.is_air')" v-model="car.is_air" dense hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                      <v-checkbox :label="$t('cars.climate_control')" v-model="car.climate_control" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.rain_sensor" :label="$t('cars.rain_sensor')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.heated_windshield" :label="$t('cars.heated_windshield')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.folding_seats" :label="$t('cars.folding_seats')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.video_system" :label="$t('cars.video_system')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.tv_system" :label="$t('cars.tv_system')" dense hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.cd_system" :label="$t('cars.cd_system')" dense hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.usb_system" :label="$t('cars.usb_system')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.audio_system" :label="$t('cars.audio_system')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.wheel_adjustment" :label="$t('cars.wheel_adjustment')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.wheel_adjustment_full" :label="$t('cars.wheel_adjustment_full')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.parktronic_camera" :label="$t('cars.parktronic_camera')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.parktronic_back" :label="$t('cars.parktronic_back')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.parktronic" :label="$t('cars.parktronic')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.heated_seats_front" :label="$t('cars.heated_seats_front')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.heated_seats" :label="$t('cars.heated_seats')" dense
                        hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox v-model="car.abs" :label="$t('cars.abs')" dense hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox :label="$t('cars.ebd')" v-model="car.ebd" dense hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-checkbox :label="$t('cars.esp')" v-model="car.esp" dense hide-details></v-checkbox>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- Раздел такси -->
          <v-col v-if="isTaxiMode" cols="12">
            <v-divider class="my-4"></v-divider>
            <h3 class="mb-4">
              <v-icon left>mdi-taxi</v-icon>
              {{ $t('taxi.vehicles.taxi_data') }}
            </h3>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-select v-model="car.taxi_vehicle_class" :items="taxiVehicleClasses"
                  :label="$t('taxi.vehicle_classes.vehicle_class')" dense outlined clearable></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="car.taxi_permit_number" :label="$t('taxi.vehicles.permit_number')" dense outlined
                  clearable></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-menu v-model="permitExpiryMenu" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="car.taxi_permit_expires_at" :label="$t('taxi.driver_documents.expiry_date')"
                      prepend-icon="mdi-calendar" readonly v-on="on" dense outlined clearable></v-text-field>
                  </template>
                  <v-date-picker v-model="car.taxi_permit_expires_at" @input="permitExpiryMenu = false"
                    :locale="$i18n.locale"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="car.yandex_vehicle_id" :label="$t('taxi.yandex_integration.yandex_vehicle_id')"
                  :hint="$t('common.optional')" persistent-hint dense outlined clearable></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions id="registration-step-36">
        <v-spacer></v-spacer>
        <v-btn color="success" @click="saveCar()" :loading="isLoading" data-testid="new-car-save">
          {{ $t("custom.save") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </span>
</template>
<script>

export default {
  data() {
    return {
      car: {
        car_name: null,
        code: null,
        sort: 0,
        number: null,
        vin: null,
        body_number: null,
        pts: null,
        registration_certificate: null,
        year: null,
        transmission: null,
        fuel: null,
        tank_value: 50,
        number_doors: 5,
        engine_capacity: null,
        is_electropackage: false,
        car_type: null,
        car_class: null,
        is_air: false,
        price_hour: null,
        deposit: null,
        insurance: null,
        oil_engine: null,
        oil_transmission: null,
        oil_engine_date: null,
        oil_engine_km: null,
        oil_transmission_km: null,
        oil_transmission_date: null,
        grm: null,
        grm_km: null,
        grm_date: null,
        antifreeze: null,
        antifreeze_km: null,
        antifreeze_date: null,
        brake_fluid: null,
        brake_fluid_km: null,
        brake_fluid_date: null,
        candle: null,
        candle_km: null,
        candle_date: null,
        power_steering: null,
        power_steering_km: null,
        power_steering_date: null,
        diagnostic_card: null,
        mileage: null,
        salon_filter_renew: null,
        salon_filter_renew_km: null,
        salon_filter_renew_date: null,
        akb_renew: null,
        akb_renew_km: null,
        akb_renew_date: null,
        fuel_filter_renew: null,
        fuel_filter_renew_km: null,
        fuel_filter_renew_date: null,
        purchase_price: null,
        purchase_date: null,
        sale_price: null,
        sale_date: null,
        tire_size: null,
        number_seats: 5,
        drive_unit: "Передний",
        engine_power: null,
        airbags: null,
        roof: "Обычная",
        gas_mileage: null,
        steering_side: "Левая",
        interior: "Ткань",
        abs: false,
        ebd: false,
        esp: false,
        window_lifters: 4,
        trunk_volume: 0,
        description: null,
        // Поля такси
        taxi_vehicle_class: null,
        taxi_permit_number: null,
        taxi_permit_expires_at: null,
        yandex_vehicle_id: null,
      },
      car_marks: [],
      car_mark: null,
      isLoadingCarMarks: false,
      car_mark_search: null,
      car_models: [],
      car_model: null,
      isLoadingCarModels: false,
      car_model_search: null,
      car_generations: [],
      car_generation: null,
      isLoadingCarGenerations: false,
      car_generation_search: null,
      car_configurations: [],
      car_configuration: null,
      isLoadingCarConfigurations: false,
      car_configuration_search: null,
      car_modifications: [],
      car_modification: null,
      isLoadingCarModifications: false,
      car_modification_search: null,
      tabs: 0,
      periods: [],
      seasons: [],
      drive_units: [
        { text: this.$t("drive_units.front"), value: "Передний" },
        { text: this.$t("drive_units.back"), value: "Задний" },
        { text: this.$t("drive_units.full"), value: "Полный" },
      ],
      car_classes: [
        { text: this.$t("car_classes.economy"), value: "Эконом" },
        { text: this.$t("car_classes.middle"), value: "Средний" },
        { text: this.$t("car_classes.business"), value: "Бизнес" },
        { text: this.$t("car_classes.commercial"), value: "Коммерческий" },
      ],
      car_types: [
        { text: this.$t("car_types.micro"), value: "Микро" },
        { text: this.$t("car_types.hatchback"), value: "Хэтчбек" },
        { text: this.$t("car_types.sedan"), value: "Седан" },
        { text: this.$t("car_types.universal"), value: "Универсал" },
        { text: this.$t("car_types.minivan"), value: "Минивен" },
        { text: this.$t("car_types.coupe"), value: "Купе" },
        { text: this.$t("car_types.crossover"), value: "Кроссовер" },
        { text: this.$t("car_types.suv"), value: "Внедорожник" },
        { text: this.$t("car_types.pickup"), value: "Пикап" },
        { text: this.$t("car_types.limousine"), value: "Лимузин" },
        { text: this.$t("car_types.van"), value: "Фургон" },
        { text: this.$t("car_types.cabriolet"), value: "Кабриолет" },
        { text: this.$t("car_types.bus"), value: "Микроавтобус" },
        { text: this.$t("car_types.campervan"), value: "Автодом" },
        { text: this.$t("car_types.light_van"), value: "Легковой фургон" },
        { text: this.$t("car_types.rodster"), value: "Родстер" },
        { text: this.$t("car_types.sportcar"), value: "Спорткар" },
      ],
      motorcycle_types: [
        { text: this.$t("motorcycle_types.sport"), value: "Спортивные (спортбайки)" },
        { text: this.$t("motorcycle_types.cruiser"), value: "Круизеры" },
        { text: this.$t("motorcycle_types.tourist"), value: "Туристические (турэндуро)" },
        { text: this.$t("motorcycle_types.enduro"), value: "Эндуро" },
        { text: this.$t("motorcycle_types.standard"), value: "Стандартные (нейкед)" },
        { text: this.$t("motorcycle_types.scooter"), value: "Скутеры" },
        { text: this.$t("motorcycle_types.chopper"), value: "Чопперы" },
        { text: this.$t("motorcycle_types.cafe_racer"), value: "Кафе рейсеры" },
        { text: this.$t("motorcycle_types.kross"), value: "Кроссовые (мотокросс)" },
        { text: this.$t("motorcycle_types.super"), value: "Супермото" },
        { text: this.$t("motorcycle_types.street"), value: "Стритфайтеры" },
        { text: this.$t("motorcycle_types.sport_tourist"), value: "Спорт-туристические" },
        { text: this.$t("motorcycle_types.moped"), value: "Мопеды" },
        { text: this.$t("motorcycle_types.truck"), value: "Трайки (трехколесные)" },
        { text: this.$t("motorcycle_types.bobber"), value: "Боббер" },
        { text: this.$t("motorcycle_types.buggy"), value: "Багги" },
      ],
      bike_types: [
        { text: this.$t("bike_types.road"), value: "Шоссейные" },
        { text: this.$t("bike_types.mtb"), value: "Горные (MTB)" },
        { text: this.$t("bike_types.city"), value: "Городские" },
        { text: this.$t("bike_types.hybrid"), value: "Гибридные" },
        { text: this.$t("bike_types.track"), value: "Трековые" },
        { text: this.$t("bike_types.gravel"), value: "Гравийные (гревел)" },
        { text: this.$t("bike_types.folding"), value: "Складные" },
        { text: this.$t("bike_types.bmx"), value: "BMX" },
        { text: this.$t("bike_types.tourist"), value: "Туристические" },
        { text: this.$t("bike_types.triathlon"), value: "Для триатлона" },
        { text: this.$t("bike_types.fatbike"), value: "Фэтбайки" },
        { text: this.$t("bike_types.cruiser"), value: "Круизеры" },
        { text: this.$t("bike_types.downhill"), value: "Даунхилл" },
        { text: this.$t("bike_types.children"), value: "Детские" },
        { text: this.$t("bike_types.tandem"), value: "Тандемы" },
        { text: this.$t("bike_types.electric"), value: "Электрические" },
        { text: this.$t("bike_types.trick"), value: "Трюковые" },
        { text: this.$t("bike_types.offroad"), value: "Внедорожные" },
        { text: this.$t("bike_types.sport"), value: "Спортивные" },
        { text: this.$t("bike_types.seat"), value: "Самокаты с сиденьем" },
        { text: this.$t("bike_types.scooter"), value: "Гироскутеры" },
        { text: this.$t("bike_types.kick"), value: "Кикскутеры" },
        { text: this.$t("bike_types.speed"), value: "Быстроходные" },
      ],
      fuels: [
        { text: this.$t("fuels.gas"), value: "Бензин" },
        { text: this.$t("fuels.gas_92"), value: "Бензин 92" },
        { text: this.$t("fuels.gas_95"), value: "Бензин 95" },
        { text: this.$t("fuels.gas_98"), value: "Бензин 98" },
        { text: this.$t("fuels.gas_100"), value: "Бензин 100" },
        { text: this.$t("fuels.disel"), value: "Дизель" },
        { text: this.$t("fuels.gas_natural"), value: "Газ" },
        { text: this.$t("fuels.gas_gasoline"), value: "Бензин/Газ" },
        { text: this.$t("fuels.electricity"), value: "Электричество" },
        { text: this.$t("fuels.hybrid"), value: "Гибрид" },
        { text: this.$t("fuels.hydrogen"), value: "Водород" }
      ],
      gears: [
        { text: this.$t("transmissions.automatic"), value: "Автомат" },
        { text: this.$t("transmissions.manual"), value: "Механика" },
        { text: this.$t("transmissions.variator"), value: "Вариатор" },
        { text: this.$t("transmissions.robot"), value: "Робот" },
      ],
      roofs: [
        { text: this.$t("roofs.ordinary"), value: "Обычная" },
        { text: this.$t("roofs.glass"), value: "Стеклянная" },
        { text: this.$t("roofs.folding"), value: "Складывающаяся" },
      ],
      steering_side: [
        { text: this.$t("steering_side.left"), value: "Левая" },
        { text: this.$t("steering_side.right"), value: "Правая" },
      ],
      interiors: [
        { text: this.$t("interiors.textile"), value: "Ткань" },
        { text: this.$t("interiors.leather"), value: "Кожа" },
      ],
      showDopPanel: false,
      isLoading: false,
      error: "",
      // Такси переменные
      permitExpiryMenu: false,
      taxiVehicleClasses: [
        { text: this.$t('taxi.vehicle_classes.econom'), value: 'econom' },
        { text: this.$t('taxi.vehicle_classes.comfort'), value: 'comfort' },
        { text: this.$t('taxi.vehicle_classes.comfort_plus'), value: 'comfort_plus' },
        { text: this.$t('taxi.vehicle_classes.business'), value: 'business' },
        { text: this.$t('taxi.vehicle_classes.premium'), value: 'premium' }
      ],
    };
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      // Освежаем счётчики main_company: снимок в Vuex живёт с логина, и за долгую
      // сессию cars_count/active_cars_count устаревают — проверка лимита в saveCar
      // молчала, пока сотрудник заводил машины сверх потолка (сервер теперь тоже
      // проверяет, здесь — ранний тост вместо 406 после заполнения формы)
      const mc = this.$store.getters.getMainCompany;
      if (mc && mc.id) {
        this.axios
          .get(`/api/v1/main_companies/${mc.id}`, {
            headers: { Authorization: this.$store.getters.getAuthToken },
          })
          .then((r) => this.$store.commit("setMainCompany", r.data))
          .catch((e) => console.error("[main_company refresh] failed:", e));
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  mounted: function () {
    if (this.$tours["registrationTour"]) {
      this.$tours["registrationTour"].nextStep();
    }
  },
  watch: {
    car_mark() {
      if (this.car_mark) {
        this.car.car_mark_id = this.car_mark.id;
        this.isLoading = true;
        this.isLoadingCarModels = true;
        this.axios
          .get(`/api/v1/car_models?car_mark_id=${this.car_mark.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.car_models = response.data;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => {
            this.isLoadingCarModels = false;
            this.isLoading = false;
          });
      } else {
        this.car_models = [];
        this.car_generations = [];
        this.car_configurations = [];
        this.car_modifications = [];
      }
    },
    car_model() {
      if (this.car_model) {
        this.car.car_model_id = this.car_model.id;
        this.isLoading = true;
        this.isLoadingCarGenerations = true;
        this.car.car_name = `${this.car_mark.name} ${this.car_model.name}`;
        this.car.code = `${this.car_mark.name[0]}${this.car_model.name[0]}1`;
        this.axios
          .get(`/api/v1/car_generations?car_model_id=${this.car_model.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.car_generations = response.data;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => {
            this.isLoadingCarGenerations = false;
            this.isLoading = false;
          });
      } else {
        this.car_generations = [];
        this.car_configurations = [];
        this.car_modifications = [];
      }
    },
    car_generation() {
      if (this.car_generation) {
        this.car.car_generation_id = this.car_generation.id;
        this.isLoadingCarConfigurations = true;
        this.isLoading = true;
        this.axios
          .get(
            `/api/v1/car_configurations?car_generation_id=${this.car_generation.id}`,
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.car_configurations = response.data;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => {
            this.isLoadingCarConfigurations = false;
            this.isLoading = false;
          });
      } else {
        this.car_configurations = [];
        this.car_modifications = [];
      }
    },
    car_configuration() {
      if (this.car_configuration) {
        this.car.car_configuration_id = this.car_configuration.id;
        this.car_modifications = this.car_configuration.modifications
        if (this.car_configuration["body_type"]) {
          switch (this.car_configuration["body_type"]) {
            case 'купе': case 'купе-хардтоп':
              this.car.car_type = "Купе"
              break;
            case 'родстер': case 'тарга': case 'спидстер':
              this.car.car_type = "Родстер"
              break;
            case 'седан': case 'седан 2 дв.': case 'лифтбек': case 'седан-хардтоп':
              this.car.car_type = "Седан"
              break;
            case 'хэтчбек 3 дв.': case 'хэтчбек 5 дв.': case 'хэтчбек 4 дв.':
              this.car.car_type = "Хэтчбек"
              break;
            case 'внедорожник 5 дв.': case 'внедорожник 3 дв.': case 'внедорожник открытый':
              this.car.car_type = "Внедорожник"
              break;
            case 'универсал': case 'универсал 5 дв.': case 'универсал 3 дв.':
              this.car.car_type = "Универсал"
              break;
            case 'кабриолет':
              this.car.car_type = "Кабриолет"
              break;
            case 'минивэн': case 'микровэн': case 'компактвэн':
              this.car.car_type = "Минивен"
              break;
            case 'фургон':
              this.car.car_type = "Фургон"
              break;
            case 'пикап': case 'пикап одинарная кабина': case 'пикап полуторная кабина': case 'пикап двойная кабина':
              this.car.car_type = "Пикап"
              break;
            case 'лимузин':
              this.car.car_type = "Лимузин"
              break;
            default:
              console.log(this.car_configuration["body_type"])
              break;
          }
        }
      } else {
        this.car_modifications = [];
      }
    },
    car_modification() {
      if (this.car_modification) {
        console.log(this.car_modification.specifications)
        this.car.car_complectation_id = this.car_modification["complectation-id"];
        if (this.car_modification.specifications.transmission) {
          let self = this
          switch (this.car_modification.specifications.transmission) {
            case 'механическая':
              self.car.transmission = "Механика"
              break;
            case 'автоматическая':
              self.car.transmission = "Автомат"
              break;
            case 'робот':
              self.car.transmission = "Робот"
              break;
            case 'вариатор':
              self.car.transmission = "Вариатор"
              break;
            default:
              break;
          }
        }
        if (this.car_modification.specifications["doors-count"]) {
          this.car.doors_count = this.car_modification.specifications["doors-count"]
        }
        if (this.car_modification.specifications["fuel-tank-capacity"]) {
          this.car.tank_value = this.car_modification.specifications["fuel-tank-capacity"]
        }
        if (this.car_modification.specifications["horse-power"]) {
          this.car.engine_power = this.car_modification.specifications["horse-power"]
        }
        if (this.car_modification.specifications["consumption-mixed"]) {
          this.car.gas_mileage = this.car_modification.specifications["consumption-mixed"]
        }
        if (this.car_modification.specifications["volume-litres"]) {
          this.car.engine_capacity = this.car_modification.specifications["volume-litres"]
        }
        if (this.car_modification.specifications["wheel-size"]) {
          this.car.tire_size = this.car_modification.specifications["wheel-size"][0]
        }
        if (this.car_modification.specifications["drive"]) {
          switch (this.car_modification.specifications["drive"]) {
            case 'задний':
              this.car.drive_unit = "Задний"
              break;
            case 'передний':
              this.car.drive_unit = "Передний"
              break;
            case 'полный':
              this.car.drive_unit = "Полный"
              break;
            default:
              break;
          }
        }
        if (this.car_modification.specifications["fuel"]) {
          switch (this.car_modification.specifications["fuel"]) {
            case 'АИ-95':
              this.car.drive_unit = "Бензин 95"
              break;
            case 'АИ-92':
              this.car.drive_unit = "Бензин 92"
              break;
            case 'АИ-98':
              this.car.drive_unit = "Бензин 98"
              break;
            case 'газ':
              this.car.drive_unit = "Газ"
              break;
            case 'ДТ':
              this.car.drive_unit = "Дизель"
              break;
            case 'водород':
              this.car.drive_unit = "Водород"
              break;
            default:
              break;
          }
        }
      }
    }
  },
  computed: {
    company() {
      return this.$store.getters.getCompany.company;
    },
    isTaxiMode() {
      return this.company && this.company.taxi_park_type && this.company.taxi_park_type !== 'not_taxi';
    },
    main_company() {
      return this.$store.getters.getMainCompany;
    },
    rental_object() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.rental_object) {
        return this.$store.getters.getCompany.company.rental_object;
      } else {
        return 'cars';
      }
    },
    current_object_types() {
      if (this.rental_object == 'cars') {
        return this.car_types;
      } else if (this.rental_object == 'bicycles') {
        return this.bike_types;
      } else if (this.rental_object == 'motorcycles') {
        return this.motorcycle_types;
      } else {
        return this.car_types;
      }
    },
  },
  methods: {
    saveCar() {
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.cars_limit > 0 && this.$store.getters.getMainCompany.active_cars_count && this.$store.getters.getMainCompany.active_cars_count >= this.$store.getters.getMainCompany.plan.cars_limit) {
        this.$notify(this.$t("errors.tariffs_limit_reached_title"), this.$t("errors.tariffs_limit_reached_text"), "warning", 5000);
        return;
      } else if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.trial_end && this.$store.getters.getMainCompany.plan.trial_end != null && this.$store.getters.getMainCompany.cars_count >= 10) {
        this.$notify(this.$t("plans.cars_limit_reached_title"), this.$t("plans.cars_limit_reached_text"), "warning", 5000);
        return;
      } else {
        // проверяем на должника
        if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
          this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
          return;
        }
        if (this.isStaff) {
          if (this.car.car_name && this.car.code) {
            this.isLoading = true;
            this.axios
              .post(
                "/api/v1/cars",
                {
                  cars: {
                    car_name: this.car.car_name,
                    code: this.car.code,
                    sort: this.car.sort,
                    number: this.car.number,
                    vin: this.car.vin,
                    body_number: this.car.body_number,
                    pts: this.car.pts,
                    registration_certificate: this.car.registration_certificate,
                    year: this.car.year,
                    transmission: this.car.transmission,
                    fuel: this.car.fuel,
                    tank_value: this.car.tank_value,
                    number_doors: this.car.number_doors,
                    engine_capacity: this.car.engine_capacity,
                    is_electropackage: this.car.is_electropackage,
                    car_type: this.car.car_type,
                    car_class: this.car.car_class,
                    color: this.car.color,
                    is_air: this.car.is_air,
                    price_hour: this.car.price_hour,
                    deposit: this.car.deposit,
                    insurance: this.car.insurance,
                    oil_engine: this.car.oil_engine,
                    oil_engine_date: this.car.oil_engine_date,
                    oil_transmission: this.car.oil_transmission,
                    oil_engine_km: this.car.oil_engine_km,
                    oil_transmission_km: this.car.oil_transmission_km,
                    oil_transmission_date: this.car.oil_transmission_date,
                    mileage: this.car.mileage,
                    start_mileage: this.car.start_mileage,
                    grm: this.car.grm,
                    grm_km: this.car.grm_km,
                    grm_date: this.car.grm_date,
                    antifreeze: this.car.antifreeze,
                    antifreeze_km: this.car.antifreeze_km,
                    antifreeze_date: this.car.antifreeze_date,
                    brake_fluid: this.car.brake_fluid,
                    brake_fluid_km: this.car.brake_fluid_km,
                    brake_fluid_date: this.car.brake_fluid_date,
                    candle: this.car.candle,
                    candle_km: this.car.candle_km,
                    candle_date: this.car.candle_date,
                    power_steering: this.car.power_steering,
                    power_steering_km: this.car.power_steering_km,
                    power_steering_date: this.car.power_steering_date,
                    diagnostic_card: this.car.diagnostic_card,
                    salon_filter_renew: this.car.salon_filter_renew,
                    salon_filter_renew_km: this.car.salon_filter_renew_km,
                    salon_filter_renew_date: this.car.salon_filter_renew_date,
                    akb_renew: this.car.akb_renew,
                    akb_renew_km: this.car.akb_renew_km,
                    akb_renew_date: this.car.akb_renew_date,
                    fuel_filter_renew: this.car.fuel_filter_renew,
                    fuel_filter_renew_km: this.car.fuel_filter_renew_km,
                    fuel_filter_renew_date: this.car.fuel_filter_renew_date,
                    purchase_price: this.car.purchase_price,
                    purchase_date: this.car.purchase_date,
                    sale_price: this.car.sale_price,
                    sale_date: this.car.sale_date,
                    tire_size: this.car.tire_size,
                    number_seats: this.car.number_seats,
                    drive_unit: this.car.drive_unit,
                    engine_power: this.car.engine_power,
                    airbags: this.car.airbags,
                    roof: this.car.roof,
                    gas_mileage: this.car.gas_mileage,
                    steering_side: this.car.steering_side,
                    interior: this.car.interior,
                    abs: this.car.abs,
                    ebd: this.car.ebd,
                    esp: this.car.esp,
                    window_lifters: this.car.window_lifters,
                    trunk_volume: this.car.trunk_volume,
                    description: this.car.description,
                    franchise: this.car.franchise,
                    max_fine: this.car.max_fine,
                    repair_cost: this.car.repair_cost,
                    heated_seats: this.car.heated_seats,
                    heated_seats_front: this.car.heated_seats_front,
                    parktronic: this.car.parktronic,
                    parktronic_back: this.car.parktronic_back,
                    parktronic_camera: this.car.parktronic_camera,
                    wheel_adjustment: this.car.wheel_adjustment,
                    wheel_adjustment_full: this.car.wheel_adjustment_full,
                    audio_system: this.car.audio_system,
                    video_system: this.car.video_system,
                    tv_system: this.car.tv_system,
                    cd_system: this.car.cd_system,
                    usb_system: this.car.usb_system,
                    climate_control: this.car.climate_control,
                    folding_seats: this.car.folding_seats,
                    heated_windshield: this.car.heated_windshield,
                    rain_sensor: this.car.rain_sensor,
                    beacon_emai: this.car.beacon_emai,
                    beacon_phone: this.car.beacon_phone,
                    beacon_pin: this.car.beacon_pin,
                    custom_field_1: this.car.custom_field_1,
                    custom_field_2: this.car.custom_field_2,
                    custom_field_3: this.car.custom_field_3,
                    car_mark_id: this.car.car_mark_id,
                    car_model_id: this.car.car_model_id,
                    car_generation_id: this.car.car_generation_id,
                    car_configuration_id: this.car.car_configuration_id,
                    car_modification_id: this.car.car_modification_id,
                    car_complectation_id: this.car.car_complectation_id,
                  },
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then((response) => {
                this.$router.replace(`/cars/${response.data.id}`);

                this.$notify(this.$t("cars.create_car"), this.$t("cars.create_car_text"), "success");
              })
              .catch((error) => {
                if (error.response?.status == 406) {
                  // Сервер различает потолок триала и лимит тарифа — показываем соответствующий тост
                  if (error.response?.data?.error == "Trial cars limit reached") {
                    this.$notify(this.$t("plans.cars_limit_reached_title"), this.$t("plans.cars_limit_reached_text"), "warning", 5000);
                  } else {
                    this.$notify(this.$t("errors.tariffs_limit_reached_title"), this.$t("errors.tariffs_limit_reached_text"), "warning", 5000);
                  }
                  return;
                } else {
                  this.setError(error, this.$t("errors.create_car"));
                }
              })
              .finally(() => (this.isLoading = false));
          } else {
            this.$notify(this.$t("errors.required_fields"), this.$t("errors.required_fields_car"), "warning", 4000);
          }
        } else {
          this.$notify(this.$t("errors.no_access"), "", "warning");
        }
      }
    },
    translateBodyType(body_type) {
      let transtation_body_type = ""
      // Для перевода
      switch (body_type) {
        case 'купе':
          transtation_body_type = this.$t('car_base_ru.COUPE')
          break;
        case 'купе-хардтоп':
          transtation_body_type = this.$t('car_base_ru.COUPE_HARDTOP')
          break;
        case 'родстер':
          transtation_body_type = this.$t('car_base_ru.ROADSTER')
          break;
        case 'тарга':
          transtation_body_type = this.$t('car_base_ru.TARGA')
          break;
        case 'спидстер':
          transtation_body_type = this.$t('car_base_ru.SPEEDSTER')
          break;
        case 'седан':
          transtation_body_type = this.$t('car_base_ru.SEDAN')
          break;
        case 'седан 2 дв.':
          transtation_body_type = this.$t('car_base_ru.SEDAN_2_DOORS')
          break;
        case 'лифтбек':
          transtation_body_type = this.$t('car_base_ru.LIFTBACK')
          break;
        case 'седан-хардтоп':
          transtation_body_type = this.$t('car_base_ru.SEDAN_HARDTOP')
          break;
        case 'хэтчбек 3 дв.':
          transtation_body_type = this.$t('car_base_ru.HATCHBACK_3_DOORS')
          break;
        case 'хэтчбек 5 дв.':
          transtation_body_type = this.$t('car_base_ru.HATCHBACK_5_DOORS')
          break;
        case 'хэтчбек 4 дв.':
          transtation_body_type = this.$t('car_base_ru.HATCHBACK_4_DOORS')
          break;
        case 'внедорожник 5 дв.':
          transtation_body_type = this.$t('car_base_ru.ALLROAD_5_DOORS')
          break;
        case 'внедорожник 3 дв.':
          transtation_body_type = this.$t('car_base_ru.ALLROAD_3_DOORS')
          break;
        case 'внедорожник открытый':
          transtation_body_type = this.$t('car_base_ru.ALLROAD_OPEN')
          break;
        case 'универсал':
          transtation_body_type = this.$t('car_base_ru.WAGON')
          break;
        case 'универсал 5 дв.':
          transtation_body_type = this.$t('car_base_ru.WAGON_5_DOORS')
          break;
        case 'универсал 3 дв.':
          transtation_body_type = this.$t('car_base_ru.WAGON_3_DOORS')
          break;
        case 'кабриолет':
          transtation_body_type = this.$t('car_base_ru.CABRIO')
          break;
        case 'минивэн':
          transtation_body_type = this.$t('car_base_ru.MINIVAN')
          break;
        case 'микровэн':
          transtation_body_type = this.$t('car_base_ru.MICROVAN')
          break;
        case 'компактвэн':
          transtation_body_type = this.$t('car_base_ru.COMPACTVAN')
          break;
        case 'фургон':
          transtation_body_type = this.$t('car_base_ru.VAN')
          break;
        case 'пикап':
          transtation_body_type = this.$t('car_base_ru.PICKUP')
          break;
        case 'пикап одинарная кабина':
          transtation_body_type = this.$t('car_base_ru.PICKUP_ONE')
          break;
        case 'пикап полуторная кабина':
          transtation_body_type = this.$t('car_base_ru.PICKUP_ONE_HALF')
          break;
        case 'пикап двойная кабина':
          transtation_body_type = this.$t('car_base_ru.PICKUP_TWO')
          break;
        case 'лимузин':
          transtation_body_type = this.$t('car_base_ru.LIMOUSINE')
          break;
        case 'фаэтон':
          transtation_body_type = this.$t('car_base_ru.PHAETON')
          break;
        default:
          break;
      }
      return transtation_body_type;
    },
    translateTransmission(transmission) {
      let transtation_transmission = ""
      // Для перевода
      switch (transmission) {
        case 'механическая':
          transtation_transmission = this.$t('car_base_ru.MECHANICAL')
          break;
        case 'автоматическая':
          transtation_transmission = this.$t('car_base_ru.AUTOMATIC')
          break;
        case 'робот':
          transtation_transmission = this.$t('car_base_ru.ROBOT')
          break;
        case 'вариатор':
          transtation_transmission = this.$t('car_base_ru.VARIATOR')
          break;
        default:
          break;
      }
      return transtation_transmission;
    },
    translateFuel(fuel) {
      let transtation_fuel = ""
      // Для перевода
      switch (fuel) {
        case 'бензин':
          transtation_fuel = this.$t('car_base_ru.GASOLINE')
          break;
        case 'электро':
          transtation_fuel = this.$t('car_base_ru.ELECTRO')
          break;
        case 'дизель':
          transtation_fuel = this.$t('car_base_ru.DIESEL')
          break;
        case 'гибрид':
          transtation_fuel = this.$t('car_base_ru.HYBRID')
          break;
        case 'СУГ':
          transtation_fuel = this.$t('car_base_ru.LPG')
          break;
        default:
          break;
      }
      return transtation_fuel;
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        if (
          this.PageData &&
          this.PageData.backCrumb &&
          this.PageData.backCrumb.url
        ) {
          var fpath = this.PageData.backCrumb.url;
          this.$router.push({
            path: fpath,
          });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
  },
};
</script>
